module.exports = __webpack_public_path__ + "img/dns-filter.adb4b942.svg";